<template lang="pug">
  game-view
</template>

<script>
  import Game from "../components/Game.vue"

  export default {
    components: {
      "game-view": Game
    }
  }
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// Main.vue?246c0520